import delve from 'dlv'
import { SINGLES } from 'src/services/constants'
import readingTime from 'src/services/reading-time'

export const algoliaBlogPostAdapter = ({
  photo,
  author,
  categories = null,
  category,
  postSubCategory,
  title,
  timeToRead,
  metaDescription,
  slug,
  publishedAt,
  version,
  level,
}) => {
  return {
    image: photo ? { alt: title, media: { url: photo } } : null,
    title,
    publishedAt,
    categories: categories ? categories : null,
    category,
    postSubCategory: postSubCategory || null,
    timeToRead,
    description: metaDescription || null,
    link: {
      href: `${SINGLES.blog.url}/${slug}`,
    },
    author: {
      name: author.name,
      avatar: author.avatar,
      slug: author.slug,
      date: publishedAt,
    },
    version,
    level,
  }
}

export const algoliaBlogPostsAdapter = (blogPosts) => {
  return blogPosts.map((blogPost) => algoliaBlogPostAdapter(blogPost))
}

export const blogPostAdapter = ({
  image,
  title,
  content,
  publishedAt,
  slug,
  user,
  seo,
  featuredCategory,
  postCategories,
  postSubCategory,
  version,
  level,
}) => {
  const timeToRead = readingTime(content)
  return {
    image: delve(image, 'media')
      ? { alt: title, media: { ...image.media.data.attributes } }
      : null,
    photo: delve(image, 'media') ? image.media?.data?.attributes?.url : null,
    title,
    slug,
    publishedAt,
    category: featuredCategory?.data
      ? {
          id: featuredCategory.data.id,
          ...featuredCategory.data.attributes,
        }
      : null,
    categories: postCategories ? postCategories?.map(({ name }) => name) : null,
    postSubCategory: postSubCategory || null,
    description: seo && seo.metaDescription,
    timeToRead,
    link: {
      href: `${SINGLES.blog.url}/${slug}`,
    },
    author: {
      name: user?.username || null,
      image: {
        src: user?.avatar?.src ?? null,
        alt: user?.avatar?.alt ?? user?.username ?? null,
      },
      slug: user?.slug || null,
      date: publishedAt,
    },
    version: version || null,
    level: level || null,
  }
}

export const blogPostsAdapter = (blogPosts) => {
  return blogPosts?.map((blogPost) => blogPostAdapter(blogPost))
}
